import { UserRoleType } from "./user-role.types";

export enum ScannerColorStatus {
    SUCCESS = 'success',
    WARNING = 'warning',
    DANGER = 'danger',
    ALERT = 'alert'
}

export type RoleOption = {
    name: string;
    description: string;
    icon: string;
    roleType: UserRoleType;
};

export const ROLE_OPTIONS: RoleOption[] = [
    {
        name: 'Vendedor',
        description: 'Creás tickets, cargás ventas y compartís tus productos',
        icon: 'assets/icons/seller.png',
        roleType: 'seller'
    },
    {
        name: 'Jefe de Ventas',
        description: 'Supervisás a los vendedores y accedés a los reportes de ventas',
        icon: 'assets/icons/sales-manager.png',
        roleType: 'sales-manager'
    },
    {
        name: 'Recepcionista',
        description: 'Escaneás los QR en la puerta para validar entradas',
        icon: 'assets/icons/recepcionist.png',
        roleType: 'recepcionist'
    },
    {
        name: 'Administrador',
        description: 'Tenés acceso total y podés gestionar todo el sistema',
        icon: 'assets/icons/admin.png',
        roleType: 'administrator'
    },
    {
        name: 'Scanner',
        description: 'Escaneás los QR en la puerta y supervisás el control de acceso',
        icon: 'assets/icons/recepcionist.png',
        roleType: 'scanner'
    }
];

export type PaymentType = 'cash' | 'pay_at_door' | 'all';

export type PaymentTypeOption = {
    name: string;
    description: string;
    icon: string;
    paymentType: PaymentType;
};


export const PAYMENT_TYPE_OPTIONS: PaymentTypeOption[] = [
    {
        name: 'payment-product-modal.collection-type.own',
        description: 'payment-product-modal.collection-type.collection-type-alert',
        icon: 'assets/icons/recaudacion-propia.svg',
        paymentType: 'cash'
    },
    {
        name: 'payment-product-modal.collection-type.third-party',
        description: 'payment-product-modal.collection-type.third-party-description',
        icon: 'assets/icons/boleteria.svg',
        paymentType: 'pay_at_door'
    },
];
